import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class DeleteButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.general.deleteButtonLabel}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M30,4H22V0H12V4H4V6H6V32H28V6h2V4ZM14,2h6V4H14V2ZM26,30H8V6H26V30Z" />
					<rect x="10" y="8" width="2" height="20" />
					<rect x="16" y="8" width="2" height="20" />
					<rect x="22" y="8" width="2" height="20" />
				</svg>
			</i>
		</Button>;
	}
}
